import _ from 'lodash';
import { CoverDataOverview } from '../utils/models';

const useCoverSheetOverview = (): Omit<CoverDataOverview, 'required'>[] => {
	const draftPage = Array.from(document.querySelectorAll('.pdf-draft-page'));
	const pdfPages = draftPage.concat(Array.from(document.querySelectorAll('.pdf-page')));

	const startingPoint = draftPage.length > 0 ? 3 : 2;

	const startIndex = pdfPages.findIndex((element) => {
		const attribute = element.getAttribute('aria-label');
		if (attribute) return attribute.toLowerCase() === 'cover sheet';

		return false;
	});

	const elements = pdfPages.slice(startIndex).map((element, index) => ({
		// We add 2 here because the first page must not contain .pdf-page selector else we'll have an empty page and index starts from 0
		attribute: element.getAttribute('aria-label'),
		page: startIndex + startingPoint + index,
		identifier: element.getAttribute('data-id'),
		subidentifier: element.getAttribute('data-sub-id'),
	}));

	const uniqueElementSections = _.groupBy(elements, 'attribute');
	const overview = [];

	let initialNumber = 1;
	for (const [key, value] of Object.entries(uniqueElementSections)) {
		const pages = value.map((item) => item.page);

		overview.push({
			report: initialNumber + '. ' + key,
			page: pages.length > 1 ? `${pages[0]} - ${pages.at(-1)}` : pages.join(', '),
			subpages: _.groupBy(value.map((item) => ({ id: item.identifier, page: item.page })), 'id'),
			subidentifierpages: _.groupBy(value.map((item) => ({ id: item.subidentifier, page: item.page })), 'id'),
		});

		initialNumber += 1;
	}

	return overview;
};

export default useCoverSheetOverview;
